import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiClient } from "../../../api/httpClient";

/** Fetches feature flags for the logged-in internal user (non-admin IU pages). */
export default function useInternalUserFeatures() {
  const internalUserId = useSelector((state) => state.auth.role_id);
  const [userFeatures, setUserFeatures] = useState([]);

  useEffect(() => {
    const fetchInternalUser = async () => {
      try {
        const response = await apiClient(`/get-internal-user/${internalUserId}`, "GET");
        setUserFeatures(response.features);
      } catch (error) {
        console.error("Error fetching internal user:", error);
      }
    };

    if (internalUserId) fetchInternalUser();
  }, [internalUserId]);

  return userFeatures;
}
